/**
 *  A set of Input components with title and error displays and word count
 *  Author: Teemo
 *  CreatedAt: 2021-03-03
 */
import React from 'react';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Input from '@/src/components/Antd/Input/Input';
import TopContainer from '@/src/components/Antd/Modal/TopContainer';
import CountWords from '@/src/components/CountWords/CountWords';
const InputItem = (props) => {
  const { title, maxLength = 50, err, setErr, value, setValue, help } = props;

  const handleChange = (e) => {
    setValue(e);
    if (err) setErr(false);
  };
  return (
    <TopContainer>
      <ItemWrapper
        title={title}
        rightPart={
          <CountWords count={(value || '').length} allCount={maxLength} />
        }>
        <Input
          error={err}
          autoFocus
          help={help}
          size='large'
          value={value}
          onChange={handleChange}
          maxLength={maxLength}
        />
      </ItemWrapper>
    </TopContainer>
  );
};
export default InputItem;
